import { List, ListItem, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

interface PasswordRule {
  key: string;
  regex: RegExp;
}

interface PasswordRuleListProps {
  password: string;
  isDirty?: boolean;
  rules?: PasswordRule[];
}

const DEFAULT_PASSWORD_RULES: PasswordRule[] = [
  { key: "lowercase", regex: /[a-z]/ },
  { key: "uppercase", regex: /[A-Z]/ },
  { key: "number", regex: /\d/ },
  { key: "symbol", regex: /[!@#$%^&*]/ },
  { key: "minLength", regex: /.{8,}/ },
];

export const PasswordRuleList = ({
  password,
  isDirty = true,
  rules = DEFAULT_PASSWORD_RULES,
}: PasswordRuleListProps) => {
  const t = useTranslations("PasswordRules");
  return (
    <List className="flex flex-col gap-1 p-0">
      {rules.map((rule) => {
        const isValid = rule.regex.test(password);

        return (
          <ListItem
            className="m-0 whitespace-nowrap p-0"
            key={rule.key}
            sx={{
              color: (theme) => {
                if (!isDirty || !password) {
                  return theme.palette.text.secondary;
                }

                return isValid
                  ? theme.palette.success.main
                  : theme.palette.error.main;
              },
            }}
          >
            <Typography variant="bodyS">{t(rule.key)}</Typography>
          </ListItem>
        );
      })}
    </List>
  );
};
